import React, { createContext, useContext } from 'react';
import { createTrackingPageProvider } from '@edreamsodigeo/frontend-core';
import PropTypes from 'prop-types';
import {
  CONFIRMATION,
  HOME,
  OFFERS,
  PAX,
  PAYMENT,
} from '@/hooks/usePriceFreezeRouter';

const PriceFreezeTrackingContext = createContext(null);
export const PF_PAGE_MAP = {
  [HOME]: 'BF/price-freeze/summary',
  [OFFERS]: 'BF/price-freeze/save-with-prime-plus',
  [PAX]: 'BF/price-freeze/details-extras',
  [PAYMENT]: 'BF/price-freeze/payment',
  [CONFIRMATION]: 'BF/price-freeze/confirmation',
  results: 'BF/flights/results',
  flights_results: 'BF/flights/results',
  details: 'BF/flights/details-extras',
  trip_summary: 'BF/flights/summary',
  flights_summary: 'BF/flights/summary',
  pf_intermediate: 'BF/flights/price-freeze-intermediate',
  flights_pax_page: 'BF/flights/details-extras',
  prime_fares: 'BF/price-freeze/prime-fares',
  home_pax: 'BF/price-freeze/summary-details-extras',
};

export const pageMapper = (page) => PF_PAGE_MAP[page];

const TrackingProvider = createTrackingPageProvider({
  pageMapper,
});

export const PriceFreezeTrackingProvider = ({ page = '', children }) => {
  return (
    <PriceFreezeTrackingContext.Provider value={page}>
      <TrackingProvider>{children}</TrackingProvider>
    </PriceFreezeTrackingContext.Provider>
  );
};

export const useCustomTrackingPage = () => {
  return useContext(PriceFreezeTrackingContext);
};

PriceFreezeTrackingContext.propTypes = {
  page: PropTypes.string,
};
